module.exports = __webpack_public_path__ + "img/xadrez.7b4cbd39.png";